import { useEffect, useRef } from 'react';
import { API_ROOT } from '../services/apiClient';

export function useAudio(assetUrl) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (assetUrl) {
      audioRef.current = new Audio(`${API_ROOT}${assetUrl}`);
    }
  }, [assetUrl]);

  return async () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        await audioRef.current.play();
      }
    } catch {
      // autoplay can fail silently
    }
  };
}
